const ROUTES = {
  APP_ACCOUNT: '/app/account',
  // Texting move: full-page code entry (also linked from the banner and texts).
  APP_VERIFY: '/app/verify',
  APP_MANAGEMENT_EVENTS: '/app/management/events',
  APP_MANAGEMENT_EVENT_SMART_ACTIONS: '/app/management/events/smart-actions',
  APP_MANAGEMENT_CUSTOMERS: '/app/management/customers',
  APP_MANAGEMENT_CHAT: '/app/management/connections',
  APP_MANAGEMENT_SCHEDULED_MESSAGES: '/app/management/scheduled-connections',
  APP_MANAGEMENT_GROUPS: '/app/management/groups',
  APP_HELP_AND_INFORMATION: '/app/help-and-information',
  APP_EVENT_SETTINGS: '/app/event-settings',
  APP_ORDER_SETTINGS: '/app/order-settings',
  APP_CONTACT_SETTINGS: '/app/settings/contact-settings',
  APP_CHAT_SETTINGS: '/app/settings/messaging-settings',
  APP_GROUP_SETTINGS: '/app/settings/group-settings',
  APP_GROUP_FORM_LINES: '/app/group-form/form-lines',
  APP_SMART_FIELDS_SETTINGS: '/app/settings/smart-fields',
  APP_SMART_LINKS_SETTINGS: '/app/settings/smart-links',
  APP_MESSAGE_TEMPLATES_SETTINGS: '/app/settings/messages',
  // CON-1597 — Value Lists (reusable dropdown option sets)
  APP_VALUE_LISTS: '/app/settings/lists',
  APP_SMART_FORMS: '/app/management/smart-forms',
  // CON-1552 — Share Center (universal share-code entry + Share Sets)
  APP_SHARE_CENTER: '/app/share-center',
  APP_SHARE_CENTER_HISTORY: '/app/share-center/history',
  // CON-1532 Phase 9 — Page Column Defaults admin page.
  APP_ADMIN_PAGE_COLUMN_DEFAULTS: '/app/admin/page-column-defaults',
  // CON-1488 — Admin TCR Registrations list page.
  APP_ADMIN_TCR_REGISTRATIONS: '/app/admin/tcr-registrations',
  // CON-1699 — Setup Assistant (CP texting accounts only).
  APP_SETUP_ASSISTANT: '/app/setup-assistant',
  APP_PERMISSION_DENIED: '/app/access-denied',
  APP_404: '/app/404',
};

export default ROUTES;
